<template>
  <div class="tour-refera">
    <button v-if="!isLast" @click.prevent="endTour" class="btn btn btn-danger btn-end-tour">
      End Tour
    </button>
    <div class="overlay-block" @click.stop="overlayClick"></div>
    <div class="overlay-block-all" @click.stop="overlayClick" v-if="currentStep.nextBtn || currentStep.disableInteraction"></div>
    <v-tour :name="name" :steps="steps" :callbacks="tourCallbacks">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step :key="step" :step="currentStep" :previous-step="tour.previousStep" :next-step="tour.nextStep" :stop="tour.stop" :skip="tour.skip" :is-first="tour.isFirst" :is-last="tour.isLast" :debug="true" :labels="tour.labels" :class="[currentStep.inlineBtn ? 'd-flex align-items-center' : '']">
            <template>
              <div slot="actions">
                <template v-if="!isLast && currentStep.nextBtn">
                  <button @click.prevent="$store.dispatch('tour/next')" class="btn btn-info btn-lg mx-auto d-block" :class="[currentStep.inlineBtn ? '' : 'mt-3']" style="font-size: 1rem">
                    {{ currentStep.nextBtn }}
                  </button>
                </template>
                <!-- <a
                style="font-size:.7em; font-weight:normal; cursor: pointer;"
                @click.prevent="reset"
                v-if="step < tour.steps.length - 1"
                >skip tour</a>-->
                <!-- <button
                  @click.prevent="tour.skip"
                  v-if="index < tour.steps.length - 1"
                  class="v-step__button v-step__button-skip"
                >Skip Tour</button>-->
                <!-- <button @click.prevent="tour.previousStep" v-if="!isFirst && isButtonEnabled('buttonPrevious')" class="v-step__button v-step__button-previous">{{ labels.buttonPrevious }}</button>
                -->
                <button @click.prevent="tour.finish" v-if="isLast" class="mt-3 btn btn-primary btn-lg btn-xl mx-auto d-block">
                  Finish Tour
                </button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
  </div>
</template>
<style scoped>
.overlay-block,
.overlay-block-all {
  opacity: 1;
  background-color: transparent;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  z-index: 9000;
  /* pointer-events: none; */
  -webkit-user-select: none; /* Chrome all / Safari all */
  -moz-user-select: none; /* Firefox all */
  -ms-user-select: none; /* IE 10+ */
  user-select: none; /* Likely future */
  cursor: default;

  /* position: fixed;
  z-index: 9994; */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
}
.overlay-block-all {
  z-index: 9995;
}
.btn-end-tour {
  position: fixed;
  /* bottom: 10px;
  right: 10px; */
  top: 10px;
  right: 10px; /* calc(50% - 76.5px);*/
  z-index: 10010;
  padding: 0.5rem 3rem;
  width: 170px;
  font-weight: bolder;
}
</style>
<script>
import { mapState, mapGetters } from 'vuex'

export default {
  props: ['name'],
  data() {
    return {
      highlightClass: 'v-tour__target--highlighted',
      tourCallbacks: {
        onPreviousStep: this.onTourPrev,
        onNextStep: this.onTourNext,
        onStop: this.onTourStop,
        onStart: this.onTourStart,
      },
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('tour', ['step', 'activeTour']),
    ...mapGetters('auth', ['isDemo']),
    ...mapGetters('tour', ['getSteps']),
    currentStep() {
      return this.steps[this.step]
    },
    currentTarget() {
      return document.querySelector(this.currentStep.target)
    },
    steps() {
      return this.getSteps(this.$store)
    },
    isLast() {
      return this.step === this.steps.length - 1
    },
  },
  methods: {
    onTourPrev(step) {
      this.handleStep(step - 1, step)
    },
    onTourNext(step) {
      return this.handleStep(step + 1, step)
    },
    async onTourStart() {
      if (this.step === 0) {
        // this.$store.dispatch('tour/reset')
        await this.handleStep(0)
      }
    },
    onTourStop() {
      this.endTour()
    },
    async reset() {
      this.clearHighlighted()
      document.body.classList.remove('v-tour--active')
      await this.$store.dispatch('tour/reset')
    },
    clearHighlighted() {
      Array.from(document.querySelectorAll('.' + this.highlightClass)).map(
        (o) => o.classList.remove(this.highlightClass, 'bg-white')
      )
    },
    async handleStep(step, previous) {
      const objStep = this.steps[step]
      if (typeof objStep.onEnter === 'function') {
        try {
          await Promise.resolve(
            objStep.onEnter.call(this, document.querySelector(objStep.target))
          )
        } catch (err) {
          this.$exception(err)
        }
      }
      let el = document.querySelector(objStep.target)
      this.clearHighlighted()
      if (objStep.whiteBg) {
        el.classList.add('bg-white')
      }
      el.classList.add(this.highlightClass)
      if (typeof objStep.onEntered === 'function') {
        try {
          await Promise.resolve(objStep.onEntered.call(this, el))
        } catch (err) {
          this.$exception(err)
        }
      }
    },
    onClick(e) {
      if (
        this.activeTour &&
        this.currentTarget &&
        this.step > -1 &&
        this.currentStep.anyClick
      ) {
        if (
          e.target === this.currentTarget ||
          this.currentTarget.contains(e.target)
        ) {
          this.$store.dispatch('tour/next')
        }
      }
    },
    onMessage(e) {
      try {
        if (!e.data || !e.data.type || e.data.type != 'get-referral') return
        const data = e.data
        if (data && data.payload) {
          e.source.postMessage(
            {
              type: 'referral',
              payload: this.$store.getters['referrals/get'](data.payload),
            },
            e.origin
          )
        }
      } catch (err) {
        this.$exception(err)
      }
    },
    overlayClick(e) {},
    async endTour(e) {
      if (this.isDemo) {
        this.$store.dispatch('auth/clientLogout', true)
        window.location = 'https://www.refera.com/end-tour'
      } else {
        await this.reset()
        this.$router.push('/')
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onClick)
    window.removeEventListener('message', this.onMessage)
    this.reset()
  },
  mounted() {
    document.addEventListener('click', this.onClick)

    window.addEventListener('message', this.onMessage, false)

    this.$tours[this.name].start()
  },
  watch: {
    async $route(to, from) {
      if (to.path === '/referral/create' && this.step === 0) {
        this.$store.dispatch('tour/next')
      }
    },
    async step(step, previous) {
      this.handleStep(step, previous)
    },
  },
}
</script>
